import { TFunction } from 'i18next';

export type FilterValuesType = {
  requestType: Record<string, any> | undefined;
  status: Record<string, any> | undefined;
  ialn: Record<string, any> | undefined;
  startDate: Date | string | undefined;
  endDate: Date | string | undefined;
  premiumDiscountIndicator?: string | undefined;
  fraudDetectionIndicator?: string | undefined;
  masterPoolNumber?: Record<string, any> | undefined;
};

export type DropdownOptionType = {
  id: number;
  label: string;
  value: string;
  isGroup: string;
  groupName: string;
};

export type FormErrorsType = {
  fromDate?: boolean;
  toDate?: boolean;
};

export enum MasterPoolStatusEnum {
  'Entered' = '00',
  'Received' = '01',
  'Cancelled' = '02',
  'Rejected' = '03',
  'Refused' = '04',
  'Withdrawn' = '05',
  'Approved' = '06',
  'Issued' = '07',
  'Risked' = '08',
  'Finalized' = '09',
  'Saved' = '10',
  'Priced' = '11',
  'Offer' = '12',
  'Lock' = '14',
  'Expired' = '15',
  'New' = '90',
  'Rerisk' = '91',
  'Critical' = '99'
}

export type TranslationType = TFunction<'HbtMasterPool', undefined>;
